import { useDevCompanion } from '@/components/features/DevCompanion/DevCompanion.store';
import { api } from '@/utils/api';
import { getSupportedChainById } from '@/utils/getChain';
import { Button, Flex, FlexProps, Heading, Input, Text } from '@chakra-ui/react';
import useTranslation from 'next-translate/useTranslation';
import { useCallback, useState } from 'react';
import { toast } from 'sonner';

const DeleteGame = (props: FlexProps) => {
  const { t } = useTranslation('companion');
  const deleteGame = api.admin.deleteGame.useMutation();
  const chainId = useDevCompanion(state => state.chainId);

  const [slug, setSlug] = useState<string>('');
  const [isLoading, setLoading] = useState<boolean>(false);

  const handleSet = useCallback(async () => {
    const chain = getSupportedChainById(chainId);
    if (!chain || !slug) return;
    setLoading(true);

    try {
      const { count } = await deleteGame.mutateAsync({
        chainId,
        slug,
      });

      if (!count) throw new Error(t('delete-game.no-results-toast'));

      toast.success(t('delete-game.success-toast'));
    } catch (error) {
      console.error(error);
      toast.error(error instanceof Error ? error.message : t('delete-game.error-toast'));
    } finally {
      setSlug('');
      setLoading(false);
    }
  }, [chainId, deleteGame, slug, t]);

  return (
    <Flex direction="column" {...props}>
      <Heading fontSize="md" fontWeight="bold">
        {'Delete game'}
      </Heading>
      <Text fontSize="sm" color="muted" mt="space.4">
        {'Delete a game overview page.'}
      </Text>
      <Flex gap="space.8" my="space.8" direction="column">
        <Input
          value={slug}
          onChange={e => setSlug(e.target.value)}
          onFocus={() => setSlug('')}
          placeholder={t('delete-game.slug-placeholder')}
          size="sm"
        />
        <Button
          onClick={handleSet}
          isLoading={isLoading}
          isDisabled={isLoading}
          variant="clear"
          fontWeight="bold"
          size="sm"
          w="fit-content"
        >
          {t('delete')}
        </Button>
      </Flex>
    </Flex>
  );
};

export default DeleteGame;
